import Vue from 'vue';

import { app } from '../app';
import '../components/product';

function initCollectionVueInstance() {
  new Vue({
    el: '#bc-quickview-popup-wrapper',

    delimiters: ['${', '}'],

    methods: {
      collectionAddToCart(payload, quantity = 1) {
        return app.addToCart(payload, quantity);
      }
    },

    created(){
      $('body').css('overflow','hidden');
    },

    mounted(){

      var checkPopupSlider = setInterval(() => {
        if (document.querySelector('.bc-modal-wrapper .slick-list')) {
            clearInterval(checkPopupSlider);
            setTimeout(() => {
              document.querySelector('.bc-modal-wrapper .slick-list').style.height = "auto";
              document.querySelector('.bc-modal-wrapper .slick-list').style['max-height'] = "450px";
            }, 300);
        }
    }, 300);
    },
  });
}

(function() {

  $(document).on('click', '.bc-modal-icon-close, .mask', () => {
    $('body').css('overflow', 'auto');
  });

  $(document).on('click', '.bc-quickview-btn', () => {

    const quickviewObserver = new MutationObserver((mutations) => {
      quickviewObserver.disconnect();
      initCollectionVueInstance();

    });
    const obsConfig = { subtree: true, childList: true };
    setTimeout(() => {
      quickviewObserver.observe(document.querySelector('#bc-quickview-popup-wrapper'), obsConfig);
    }, 100);
    
  });



  $(document).on('click touchend', '.iWishAddColl',function() {

    var iWishvId = $((this)).attr("data-variant");
    if ($(this).hasClass('iwishAdded')) {
      iwish_remove(jQuery(this), iWishvId);
      $(this).removeClass("iwishAdded");
    } else {
      showToast();
      iwish_addCollection($(this),iWishvId);
    }
    return false;
  });

  $(document).on('click', '.iWishAdd',function() {
      if($(this).hasClass('iwishAdded')){
          showToast();

      }
  });


  var toaster = document.querySelector(".toaster");

  function showToast(){
    toaster.classList.add("scale-in-hor-right");
      setTimeout( function(){
        toaster.classList.remove("scale-in-hor-right");
      }, 3000 );
    
    }
    

    // close filter if on select one
    $(document).on('click', '.bc-sf-filter-option-box li a, .bc-sf-filter-option-swatch.circle-grid li a',function() {
        $('#bc-sf-filter-tree-mobile button').trigger('click');
    });
   

})();

